import { createSelector } from '@reduxjs/toolkit'

import type { QueryResultLike } from '@krp/client-runtime'

import { sameId } from '../../../shared/api/wire'
import type { AqsiSource, SourceCaptionVm, SourcePurpose } from './types'

const EMPTY_SOURCES: readonly AqsiSource[] = []

export interface SourceCaptionVmInput {
  /** Цель окна; `query` — список кабинетов, отобранный сервером по праву ЭТОЙ цели. */
  purpose: SourcePurpose
  resourceId: string
  query: QueryResultLike<readonly AqsiSource[]>
}

/**
 * Подпись источника в окне ресурса. Имя — из реестра; пока реестр не
 * ответил или ресурс в нём не виден — rid как есть, а не пустота.
 */
export const makeSelectSourceCaption = () =>
  createSelector(
    [
      (input: SourceCaptionVmInput) => input.query.data ?? EMPTY_SOURCES,
      (input: SourceCaptionVmInput) => input.resourceId,
    ],
    (available, resourceId): SourceCaptionVm => {
      const source = available.find((item) => sameId(item.id, resourceId))
      return {
        name: source?.displayName ?? `AQSI ${resourceId}`,
        how:
          available.length === 1 && source !== undefined && sameId(available[0]?.id ?? '', resourceId)
            ? 'выбран автоматически — доступен один'
            : null,
        alternatives: available.length,
      }
    },
  )
